module.exports = __webpack_public_path__ + "7a7245039627b81988111b9e55e1bec5.png";